import React from "react";
import Slider from "react-slick";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  NextArrow,
  PrevArrow,
} from "../../components/SlickButtons/SlickButtons";
import CardSkeleton from "../../components/Skeleton/CardSkeleton";
import useDevice from "../../hooks/useDevice";
import { useGetUserLibrary } from "../../hooks/useGetUserLibrary";
import "./UserLibrary.css";

function UserLibrary() {
  const { user } = useSelector((state) => state.auth);
  const { isMobile, isTablet } = useDevice();

  // isLoading will become 'true' immediately when removeQueries is called elsewhere
  const { data: userLibrary, isLoading } = useGetUserLibrary(user?.id);

  const settings = {
    dots: false,
    infinite: userLibrary?.length > 8, // Only scroll if we have enough items
    speed: 500,
    slidesToShow: isMobile ? 2 : isTablet ? 4 : 8,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <section className="UserLibrary">
      <Slider {...settings}>
        {isLoading
          ? Array.from({ length: 8 }).map((_, index) => (
              <CardSkeleton
                key={index}
                width={"95%"}
                height={isTablet ? "312px" : "230px"}
              />
            ))
          : userLibrary?.map((product) => (
              <Link
                to={`/product/${product.slug.toLowerCase()}`}
                className="product"
                key={product.id}
              >
                <img src={product.images[0]?.src} alt={product.name} />
                <p className="product-card-name">{product.name}</p>
              </Link>
            ))}
      </Slider>

      {!isLoading && (!userLibrary || userLibrary.length === 0) && (
        <div className="empty-library">
          <p>Your library is currently empty.</p>
        </div>
      )}
    </section>
  );
}

export default UserLibrary;
